<script>
import todoIcon from '@/assets/images/filter_icon/todo.png';

/*
 * Each entry is [SVG element name, attribute value].
 * Keeping the drawing data outside render() prevents it from being
 * rebuilt every time the sidebar updates.
 */
const TOOL_ICON_SHAPES = Object.freeze({
    notes: Object.freeze([
        Object.freeze([
            'path',
            'M496.093,189.613c-18.643-15.674-47.168-13.807-63.354,5.493l-9.727,11.508,68.945,57.849,9.288-11.466c15.975-19,13.954-47.376-5.152-63.384z'
        ]),
        Object.freeze([
            'path',
            'M301.375,350.534l-5.131,6.072c-4.453,5.332-7.661,11.704-9.272,18.457l-13.945,58.359c-1.318,5.522.601,11.323,4.951,14.971,4.234,3.558,10.206,4.591,15.601,2.285l55.063-23.877c6.372-2.769,12.085-7.031,16.538-12.319l5.149-6.092-68.954-57.856z'
        ]),
        Object.freeze([
            'polygon',
            '403.656,229.517 320.733,327.631 389.683,385.487 472.601,287.366'
        ]),
        Object.freeze([
            'path',
            'M376.02,66.504l-56.982-54.141c-5.387-5.107-12.014-8.115-18.999-10.069V90h89.052c-1.861-8.91-6.401-17.164-13.071-23.496z'
        ]),
        Object.freeze([
            'path',
            'M257.792,368.091c2.681-11.221,8.027-21.841,15.439-30.718l116.807-138.214V120h-105c-8.291,0-15-6.709-15-15V0h-225c-24.814,0-45,20.186-45,45v422c0,24.814,20.186,45,45,45h300c24.814,0,45-20.186,45-45v-35.459l-1.948,2.305c-7.368,8.775-16.875,15.85-27.466,20.465l-55.107,23.892c-15.532,6.707-33.511,4.331-46.816-6.812-13.14-11.03-18.838-28.242-14.854-44.941l13.945-58.359zM75.038,90h150c8.291,0,15,6.709,15,15s-6.709,15-15,15h-150c-8.291,0-15-6.709-15-15s6.709-15,15-15zm0,91h240c8.291,0,15,6.709,15,15s-6.709,15-15,15h-240c-8.291,0-15-6.709-15-15s6.709-15,15-15zm120,210h-120c-8.291,0-15-6.709-15-15s6.709-15,15-15h120c8.291,0,15,6.709,15,15s-6.709,15-15,15zm-120-90c-8.291,0-15-6.709-15-15s6.709-15,15-15h180c8.291,0,15,6.709,15,15s-6.709,15-15,15h-180z'
        ])
    ]),

    briefcase: Object.freeze([
        Object.freeze([
            'path',
            'M355.943,55.057c-2.695-18.499-18.824-32.45-37.518-32.45H193.576c-18.695,0-34.824,13.951-37.518,32.451l-6.586,45.223h31.294l5.935-40.761c.494-3.39,3.449-5.946,6.875-5.946h124.849c3.425,0,6.381,2.557,6.874,5.946l5.935,40.76h31.295l-6.586-45.223z'
        ]),
        Object.freeze([
            'path',
            'M456.449,325.807H322.39v18.075c0,5.719-3.152,10.971-8.197,13.662l-50.906,27.148c-2.277,1.214-4.781,1.822-7.287,1.822s-5.01-.607-7.287-1.822l-50.906-27.148c-5.046-2.691-8.197-7.943-8.197-13.662v-18.075H55.551c-21.132,0-40.51-7.626-55.551-20.257v164.84c0,10.478,8.525,19.004,19.004,19.004h473.992c10.478,0,19.004-8.525,19.004-19.004V305.55c-15.042,12.631-34.42,20.257-55.551,20.257z'
        ]),
        Object.freeze([
            'path',
            'M492.996,131.247H19.004C8.525,131.247,0,139.773,0,150.251v89.037c0,30.631,24.92,55.551,55.551,55.551H189.61v-27.123c0-8.551,6.933-15.484,15.484-15.484h101.813c8.551,0,15.484,6.933,15.484,15.484v27.123h134.058c30.631,0,55.551-24.92,55.551-55.551v-89.037c0-10.478-8.525-19.004-19.004-19.004z'
        ]),
        Object.freeze([
            'polygon',
            '220.578,283.201 220.578,334.592 256,353.483 291.422,334.592 291.422,283.201'
        ])
    ]),

    scheduler: Object.freeze([
        Object.freeze([
            'path',
            'M257,227.5h25c8.284,0,15-6.716,15-15s-6.716-15-15-15h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15z'
        ]),
        Object.freeze([
            'path',
            'M193,197.5h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ]),
        Object.freeze([
            'path',
            'M346,227.5h25c8.284,0,15-6.716,15-15s-6.716-15-15-15h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15z'
        ]),
        Object.freeze([
            'path',
            'M104,265H79c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ]),
        Object.freeze([
            'path',
            'M193,265h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ]),
        Object.freeze([
            'path',
            'M297,280c0-8.284-6.716-15-15-15h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15z'
        ]),
        Object.freeze([
            'path',
            'M104,332.5H79c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ]),
        Object.freeze([
            'path',
            'M193,332.5h-25c-8.284,0-15,6.716-15,15s6.716,15,15,15h25c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ]),
        Object.freeze([
            'path',
            'M450,279.076V85c0-30.327-24.673-55-55-55h-29V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v15h-54V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v15h-54V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v15h-54V15c0-8.284-6.716-15-15-15S84,6.716,84,15v15H55C24.673,30,0,54.673,0,85v300c0,24.813,20.187,45,45,45h224.622C287.19,477.805,333.177,512,387,512c68.925,0,125-56.075,125-125,0-45.965-24.943-86.209-62-107.924zM30,85c0-13.785,11.215-25,25-25h29v15c0,8.284,6.716,15,15,15s15-6.716,15-15V60h54v15c0,8.284,6.716,15,15,15s15-6.716,15-15V60h54v15c0,8.284,6.716,15,15,15s15-6.716,15-15V60h54v15c0,8.284,6.716,15,15,15s15-6.716,15-15V60h29c13.785,0,25,11.215,25,25v45H30zm15,315c-8.271,0-15-6.729-15-15V160h390v106.43c-10.517-2.882-21.581-4.43-33-4.43-68.925,0-125,56.075-125,125,0,4.389.23,8.726.674,13H45zm342,82c-52.383,0-95-42.617-95-95s42.617-95,95-95,95,42.617,95,95-42.617,95-95,95z'
        ]),
        Object.freeze([
            'path',
            'M437,372h-35v-35c0-8.284-6.716-15-15-15s-15,6.716-15,15v50c0,8.284,6.716,15,15,15h50c8.284,0,15-6.716,15-15s-6.716-15-15-15z'
        ])
    ])
});

export default {
    name: 'WorkspaceToolIcon',
    functional: true,

    props: {
        name: {
            type: String,
            required: true
        }
    },

    render(createElement, context) {
        const name = context.props.name;

        if (name === 'todo_app') {
            return createElement('img', {
                class: [
                    'img-fluid',
                    'workspace_tool_icon',
                    'workspace_tool_icon--image'
                ],
                attrs: {
                    src: todoIcon,
                    alt: '',
                    'aria-hidden': 'true'
                }
            });
        }

        const shapes = TOOL_ICON_SHAPES[name] || [];
        const children = shapes.map((shape, index) => {
            const attributeName = shape[0] === 'polygon'
                ? 'points'
                : 'd';

            return createElement(shape[0], {
                key: name + '-' + index,
                attrs: {
                    [attributeName]: shape[1],
                    fill: 'currentColor'
                }
            });
        });

        return createElement(
            'svg',
            {
                class: 'workspace_tool_icon',
                attrs: {
                    width: '35',
                    height: '35',
                    viewBox: '0 0 512 512',
                    focusable: 'false',
                    'aria-hidden': 'true'
                }
            },
            children
        );
    }
};
</script>
